<template>
  <div>
    <title-header title='支付密码设置'></title-header>
    <div class='pwd-content'>
      <!-- 手机验证码，第一次设置密码和忘记密码时展示 -->
      <div class='phone-verify-box' v-show='showPhoneVerify'>
        <i class="iconfont icon-shouji phone-icon"></i>
        <div v-if='!hasPayPwd'>为了您的账户安全，需要验证您的手机</div>
        <div v-else>通过手机验证码修改密码</div>
        <div class='phone'>{{phone | hidePhone}}</div>
        <van-field
          v-model="phoneCode"
          size="large"
          label="验证码"
          placeholder="请输入短信验证码"
        >
          <van-button slot="button" size="small" color="#45C5DA" type="primary" @click="sendCode">
            <span v-show="!display.showWait">发送验证码</span>
            <span v-show="display.showWait">{{waitSecond}}s</span>
          </van-button>
        </van-field>
      </div>
      <!-- 使用旧密码修改密码 -->
      <van-field
        style='margin-top:40px;'
        v-show='!showPhoneVerify'
        type='password' 
        v-model="oldPayPwd" 
        label='旧密码' 
        readonly
        clickable 
        size="large" 
        @click.native.stop="showKeyboard0"
        placeholder="请输入旧密码"
      ></van-field>
      <van-field
        type='password' 
        v-model="payPwd" 
        label='密码' 
        readonly
        clickable 
        size="large" 
        @click.native.stop="showKeyboard1"
        placeholder="请输入提现密码"
      ></van-field>
      <van-field
        type='password' 
        v-model="confirmPwd" 
        label='确认密码' 
        size="large" 
        readonly
        clickable 
        placeholder="请再次输入密码"
        @touchstart.native.stop="showKeyboard2"
      ></van-field>
      <div class='gorgetPwd-btn' @click='forgetPwd' v-show='showForgetPwd'>忘记密码?</div> 
      <van-button style="width: 35vw;margin-top:40px;" color='#45C5DA' @click="setPayPwd">完成</van-button>
    </div>
    <van-number-keyboard
      v-model="oldPayPwd"
      :show="display.keyboard0"
      :maxlength="6"
      @blur="display.keyboard0 = false"
    />
    <van-number-keyboard
      v-model="payPwd"
      :show="display.keyboard1"
      :maxlength="6"
      @blur="display.keyboard1 = false"
    />
    <van-number-keyboard
      v-model="confirmPwd"
      :show="display.keyboard2"
      :maxlength="6"
      @blur="display.keyboard2 = false"
    />
    <geetest
      ref="geetest"
      :phone="phone"
      :page-code="pageCode"
      :val-code="pageCode"
      @send-code-success="handlerSendCodeSuccess"
      @send-code-error="handlerSendCodefailed"
    ></geetest>
  </div>
</template>
<script>
  let md5 = require('md5');
  import geetest from "components/geetest/geetest.vue";
  import { Toast } from 'vant';
  import api from 'api/security-center';
  import { randomString } from 'common/js/utils';
  import { mapActions } from 'vuex';
  export default {
    components: {
      geetest
    },
    data() {
      return {
        value: '',
        display: {
          showWait: false,
          keyboard0: false,
          keyboard1: false,
          keyboard2: false,
          forgetPwd: true, //忘记密码
        },
        phoneCode:'',
        waitSecond: 60,
        oldPayPwd: '',//旧密码
        payPwd: '', //密码
        confirmPwd: '',//确认密码
        pageCode: randomString(8), //手机验证所需要的随机字符串
      }
    },
    computed:{
      //显示手机验证码验证
      showPhoneVerify() {
        return this.$store.state.userInfo.hasPayPwd != 0 || !this.display.forgetPwd
      },
      //显示忘记密码
      showForgetPwd() {
        return this.$store.state.userInfo.hasPayPwd == 0 && this.display.forgetPwd
      },
      phone() {
        const phone = this.$store.state.userInfo.mobilePhone
        if(phone) {
          return phone
        }
        return ''
      },
      hasPayPwd() { //是否已经设置密码
        return this.$store.state.userInfo.hasPayPwd === 0
      }
    },
    methods:{
      //点击忘记密码则使用手机验证码修改密码
      forgetPwd(){
        this.display.forgetPwd = false;
      },
      //发送验证码
      sendCode() {
        if (this.display.showWait) return
        this.$refs.geetest.verify();
      },
      // 发送验证码成功
      handlerSendCodeSuccess(res) {
        this.display.showWait = true;
        this.secondWait()
      },
      // 发送错误
      handlerSendCodefailed(err) {
        console.log(err);
      },
      showKeyboard0() {
        this.display.keyboard0 = true;
        this.display.keyboard1 = false;
        this.display.keyboard2 = false;
      },
      //显示数字键盘1,密码框
      showKeyboard1() {
        this.display.keyboard0 = false;
        this.display.keyboard2 = false;
        this.display.keyboard1 = true;
      },
      //显示数字键盘2，确认密码框
      showKeyboard2() {
        this.display.keyboard2 = true;
        this.display.keyboard0 = false;
        this.display.keyboard1 = false;
      },
      //设置支付密码
      setPayPwd() {
        if(!this.payPwd || !this.confirmPwd || (!this.phoneCode && this.showPhoneVerify) || (!this.showPhoneVerify && !this.oldPayPwd)) {
          Toast('请将信息填写完整');
          return;
        }
        if(this.payPwd.length < 6) {
          Toast('密码长度必须为6位');
          return;
        }
        if(this.payPwd !== this.confirmPwd) {
          Toast('两次密码不一致');
          return;
        }
        //没有设置过密码
        if (!this.hasPayPwd) {
          const params = {
            payPwd: this.payPwd,
            smsCode: this.phoneCode
          }
          api.setPayPwd(params)
            .then(res=>{
              Toast.success('设置成功')
              this.getuserInfo()
              this.$router.go(-1);
            })
            .catch(res => {
              Toast.fail('设置失败')
            })
        }
        //设置过密码则修改
        else{
          let params = {};
          //根据短信验证码设置密码
          if(this.showPhoneVerify) { 
            params = {
              newPayPwd: md5(this.payPwd),
              smsCode: this.phoneCode
            }
          }
          //通过旧密码设置新密码
          else{ 
            params = {
              newPayPwd: md5(this.payPwd),
              oldPayPwd: md5(this.oldPayPwd)
            }
          }
          api.updatePayPwd(params)
            .then(res=>{
              Toast.success('修改成功')
              this.$router.go(-1);
            })
            .catch(res => {
              Toast.fail('修改失败')
            })
        }
      },
      secondWait: function() {
        let _this = this;
        _this.setInercalID = setTimeout(function() {
          if (_this.waitSecond > 0) {
            _this.waitSecond = _this.waitSecond - 1;
            _this.secondWait();
          } else {
            _this.display.showWait = false;
            clearTimeout(_this.setInercalID);
            _this.waitSecond = 60;
          }
        }, 1000);
      },
      ...mapActions(['getuserInfo'])
    }
  }
</script>
<style scoped lang='scss'>
  @import 'common/sass/theme';
  .pwd-content{
    display: flex;
    flex-direction: column;
    align-items: center;
    .phone-verify-box{
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100vw;
    }
    .phone-icon{
      margin-top: 50px;
      font-size: 35px;
      font-weight: bold;
      color: #000;
    }
    .phone{
      margin-bottom: 20px;
    }
    .gorgetPwd-btn{
      width: 100vw;
      margin: 10px 10px 0 0;
      text-align: right;
      font-size: 14px;
      color: $theme-color;
    }
  }
</style>